import { Type } from '@angular/core';
import { FloatingPanelService } from '@shared/floating-panel/floating-panel.service';
import { FloatingPanelRef } from '@shared/floating-panel/floating-panel.types';

/** Paneel-data van de chart-basics-panelen: eigen paneel (default) of het overzicht met alle secties. */
export type HdChartBasicsInfoPanelMode = 'own' | 'all';

/**
 * Opent vanuit een chart-basics-paneel het bijhorende overzichtspaneel ("Toon
 * alle …", inklapbare lijst) naast het eigen paneel: zelfde dock-zone en
 * dezelfde gedockte/zwevende staat als het paneel waaruit het geopend wordt,
 * zodat het als extra tab in dezelfde zijbalk landt.
 */
export function hdOpenAllInfoPanel<TComponent, TData>(
  floatingPanels: FloatingPanelService,
  origin: FloatingPanelRef | null,
  options: { key: string; component: Type<TComponent>; data: TData; tabLabel: string },
): void {
  const docked = origin?.state() === 'docked';
  floatingPanels.openOrFocus<TComponent, TData>({
    key: options.key,
    component: options.component,
    data: options.data,
    dockTab: { label: options.tabLabel },
    dockZone: origin?.dockZone(),
    closable: true,
    openInitiallyDocked: docked,
    redockOnReopen: docked,
    startPosition: 'center',
  });
}
